import Route from '@ember/routing/route';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppServicesWaldenVasModel = Resolved<
  ReturnType<AppServicesWaldenVasRoute['model']>
>;

export default class AppServicesWaldenVasRoute extends Route {}
